import { ReactElement } from 'react';

interface ErrorMessageprops{
	messages:string[];
}

/**
 * エラーメッセージコンポーネント
 * @returns 
 */
export function ErrorMessage(props:ErrorMessageprops): ReactElement<ErrorMessageprops>{
	const messagelist = props.messages.map((message, i) => (
		<li key = {i}>{message}</li>
	));

    return(
        <div className="error-message-area">
			<div className="message-box">
				<ul>
					{messagelist}
				</ul>
			</div>
	    </div>
    );
}